// $.datetimepicker.setLocale('ru');
jQuery('.datepicker.birthday').datetimepicker({
    timepicker:false,
    format:'d.m.Y',
    lang:'ru'
});